export default __webpack_public_path__ + "static/media/checked.f444cce4.svg";